<template>
  <div>
    <section class="text_center">
      <h2 class="header_underline">お問い合わせ送信完了</h2>
      <div class="complete_box">
        <p>お問い合わせを受け付けました。<br>サポートメッセージBOXに返信が届きますので<br>今しばらくお待ち下さい。</p>
      </div>
      <p>
        <router-link to="/" class="arrow link_main--text">トップページへ戻る</router-link>
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SupportMessageComplete'
}
</script>
